import { render } from "./GeralMv.vue?vue&type=template&id=41db1160&scoped=true"
import script from "./GeralMv.vue?vue&type=script&lang=js"
export * from "./GeralMv.vue?vue&type=script&lang=js"

import "./GeralMv.vue?vue&type=style&index=0&id=41db1160&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41db1160"]])

export default __exports__